/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { loadingProvisionalDetailConfig } from '../../config/loading.config';

export interface ILoadingProvisionalDetailPluginMethods
  extends IPluginMethodMap {
  getLoadingProvisionalDetailSync(args?: any): any;
}

export class LoadingProvisionalDetailPlugin implements IAgentPlugin {
  readonly methods: ILoadingProvisionalDetailPluginMethods;

  constructor() {
    this.methods = {
      getLoadingProvisionalDetailSync:
        this.getLoadingProvisionalDetailSync.bind(this),
    };
  }

  getLoadingProvisionalDetailSync(args?: any) {
    return {
      loading: loadingProvisionalDetailConfig,
    };
  }
}
